<template>
    <v-menu
        offset-y
        light
        v-model="isMenuOpened"
        v-if="getNavigationItems && getNavigationItems.length > 0 && getNavigationItems.filter(x => x.menu && x.menu === menu_name)"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                style="letter-spacing: 0.0292857143em; text-transform: unset"
                :height="menuH"
                tile
                class="toolbar-btn"
                text
                light
                v-on="on"
                :small="$vuetify.breakpoint.xsOnly"
            >
                <div :class="{ mw120p: $vuetify.breakpoint.xsOnly }">{{ title }}</div>
                <v-icon class="mr-1" v-if="$vuetify.breakpoint.smAndUp">{{ isMenuOpened ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
            </v-btn>
        </template>
        <v-list tile class="py-0" id="list" :color="$vuetify.theme.themes.light.primary" :small="$vuetify.breakpoint.xsOnly">
            <v-list-item
                v-for="item in getNavigationItems.filter(x => x.menu && x.menu === menu_name)"
                :to="item.to"
                :key="item.to"
                class="hidden-xs-only text-left font-weight-medium-100"
            >
                <v-list-item-title> <v-icon>{{ item.icon }}</v-icon> {{ $t(item.title) }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'MenuItems',
    props: ['menu_name', 'title'],
    data: () => ({
        drawer: true,
        isMenuOpened: false
    }),
    computed: {
        ...mapGetters('auth', ['loggedIn']),
        ...mapGetters('base', ['getNavigationItems']),
        menuH() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '48px';
                case 'sm':
                    return '48px';
                case 'md':
                    return '52px';
                case 'lg':
                    return '52px';
                case 'xl':
                    return '52px';
                default : return '52px'    
            }
        }
    },
    methods: {
        openLink(item, child) {
            const name = child.to || item.to;
            const params = item.param ? { [item.param]: child[item.param] } : {};
            this.$router.push({ name, params });
        }
    }
};
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
.letter-spacing-custom {
    letter-spacing: 0.0392857143em;
}
.toolbar-btn {
    font-weight: 300 !important;
}
</style>
